import request from '@/utils/request'

/**
 * 获取PPT预览信息
 * @param {Number} resourceId 资源ID
 */
export function getPptPreviewInfo(resourceId) {
  return request({
    url: `/amc/ppt-preview/info/${resourceId}`,
    method: 'get'
  })
}

/**
 * 获取幻灯片图片URL（带水印）
 * @param {Number} resourceId 资源ID
 * @param {Number} slideIndex 幻灯片索引（从0开始）
 */
export function getSlideImageUrl(resourceId, slideIndex) {
  return `/api/amc/ppt-preview/slide/${resourceId}/${slideIndex}`
}

/**
 * 检查PPT是否已转换
 * @param {Number} resourceId 资源ID
 */
export function checkPptConverted(resourceId) {
  return request({
    url: `/amc/ppt-preview/check/${resourceId}`,
    method: 'get'
  })
}

/**
 * 手动触发PPT转换（老师端）
 * @param {Number} resourceId 资源ID
 * @param {String} fileUrl PPT文件URL
 */
export function convertPpt(resourceId, fileUrl) {
  return request({
    url: '/amc/ppt-preview/convert',
    method: 'post',
    params: { resourceId, fileUrl }
  })
}

/**
 * 强制重新转换PPT（清除缓存后重新转换）
 * @param {Number} resourceId 资源ID
 */
export function reconvertPpt(resourceId) {
  return request({
    url: `/amc/ppt-preview/reconvert/${resourceId}`,
    method: 'post'
  })
}
